import { Navigate, createBrowserRouter, RouterProvider } from 'react-router-dom';

import {
    ClassContainer,
    ClassEditPage,
    ClassCreatePage,
    ErrorPage,
    ProvidersPage,
    ClassListPageV2,
    AttendancePage,
} from '@/containers';
import { App, appLoader } from '@/containers/App';
import { parameters, redirect } from '@/routing/paths';
import { AppProviders } from '@/utils/Providers';

import type { RouteObject } from 'react-router-dom';

const classPages = (globals = window): RouteObject[] => [
    {
        path: 'new',
        element: <ClassCreatePage globals={globals} />,
    },
    {
        path: parameters.classroomId,
        element: <ClassContainer />,
        children: [
            { index: true },
            { path: 'detail' },
            { path: `labs/${parameters.labNumber}` },
            { path: 'notes' },
        ],
    },
    {
        path: `${parameters.classroomId}/edit`,
        element: <ClassEditPage />,
    },
    {
        path: `${parameters.classroomId}/attendance`,
        element: <AttendancePage />,
    },
];

export const routerConfig = (config: { globals?: typeof window; providerProps?: any } = {}) => {
    const { globals = window, providerProps = {} } = config;
    return [
        {
            path: '/',
            element: (
                <AppProviders globals={globals} {...providerProps}>
                    <App />
                </AppProviders>
            ),
            errorElement: <ErrorPage />,
            loader: appLoader,
            children: [
                {
                    index: true,
                    element: <Navigate replace to={redirect(globals)} />,
                },
                {
                    path: 'callback',
                    element: <Navigate replace to={redirect(globals)} />,
                },
                {
                    path: 'providers',
                    element: <ProvidersPage />,
                },
                {
                    path: 'classes',
                    children: [
                        {
                            index: true,
                            element: <ClassListPageV2 />,
                        },
                        ...classPages(globals),
                    ],
                },
                // NOTE: the /class/* paths are here for backwards compatibility reasons
                // would like to remove them eventually and use /classes/* as the convention
                {
                    path: 'class',
                    children: classPages(globals),
                },
            ],
        },
    ];
};

export const AppRouter = ({ globals = window }) => (
    <RouterProvider router={createBrowserRouter(routerConfig({ globals }))} />
);
